import { DatePicker } from "@progress/kendo-react-dateinputs";
import "@progress/kendo-theme-default/dist/all.css";

const DateInput = ({
  label,
  name,
  value,
  onChange,
  required,
  error,
  min,
  max,
  disabled = false,
}) => (
  <div className="form-floating mb-3 position-relative">
    <DatePicker
      id={name}
      name={name}
      value={value}
      onChange={(e) => onChange({ target: { name, value: e.value } })}
      min={min}
      max={max}
      format="dd-MM-yyyy"
      disabled={disabled}
      className={`form-control ${error ? "is-invalid" : ""}`}
    />
    <label htmlFor={name}>
      {label} {required && <span className="text-danger">*</span>}
    </label>
    {error && <div className="invalid-feedback d-block">{error}</div>}
  </div>
);

export default DateInput;
